import { useTranslation } from 'react-i18next';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import { Badge } from '../Badge';
import { CircularProgress } from '../CircularProgress';

interface AnalysisBadgeProps {
    progress?: number;
}

export function AnalysisBadge({ progress = 0 }: AnalysisBadgeProps) {
    const { t } = useTranslation(I18nNamespace.SOURCES);
    return (
        <Badge variant="analyzing">
            <CircularProgress
                progress={progress}
                size={3.25}
                className="text-grey-100"
            />
            <span className="text-xs-medium px-0.5">
                {t('status.analyzingShort')}
            </span>
        </Badge>
    );
}
